export default {"src":"/_next/static/media/downloadBrand.2e9c1cb1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};